module.exports = __webpack_public_path__ + "img/img_result_clean_pass_price_bg.9f912bcd.png";